import { useState } from 'react';
import api from '../../api/index.js';
import Header from '../../components/Header/Header';
import Loader from '../../components/Loader/Loader';
import s from './PricesStat.module.scss';

const PricesStat = () => {
  const [prices, setPrices] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadData = async () => {
    setLoading(true);
    setError(null);
    const res = await api.statistic.getGoodsPrices();
    if (res.error) {
      setError(res.error);
    } else {
      setPrices(res.prices ?? []);
    }
    setLoading(false);
  };

  const buildStats = (list) => {
    const byApi = {};
    let updated = 0;
    let popular = 0;

    list.forEach((item) => {
      const src = item.price_source_api || 'unknown';
      byApi[src] = (byApi[src] || 0) + 1;
      if (item.is_item_updated) updated++;
      if (item.is_popular) popular++;
    });

    return { total: list.length, byApi, updated, popular };
  };

  const stats = prices ? buildStats(prices) : null;

  return (
    <>
      <Header
        title="Статистика цен API"
        breadCrumbs={[
          { name: 'Главная', link: '/' },
          { name: 'Аналитика', link: '/analytics' },
          { name: 'Статистика цен', link: '/analytics/prices' },
        ]}
      />
      <div className="container">
        {!prices && !loading && (
          <div className={s.startWrap}>
            <p className={s.hint}>
              Запрос загружает все цены из API (~100 000 записей) и может занять
              некоторое время.
            </p>
            <button className="btn dark" onClick={loadData}>
              Загрузить данные
            </button>
          </div>
        )}

        {loading && (
          <div className={s.loaderWrap}>
            <Loader />
            <p className={s.hint}>Загружаем данные, это может занять до минуты…</p>
          </div>
        )}

        {error && (
          <div className={s.errorWrap}>
            <p className={s.error}>{error}</p>
            <button className="btn dark" onClick={loadData}>
              Повторить
            </button>
          </div>
        )}

        {stats && (
          <>
            <div className={s.metrics}>
              <div className={s.metricCard}>
                <span className={s.metricLabel}>Всего товаров с ценой</span>
                <span className={s.metricValue}>
                  {stats.total.toLocaleString('ru-RU')}
                </span>
              </div>
              <div className={s.metricCard}>
                <span className={s.metricLabel}>Обновлено</span>
                <span className={s.metricValue + ' ' + s.green}>
                  {stats.updated.toLocaleString('ru-RU')}
                </span>
              </div>
              <div className={s.metricCard}>
                <span className={s.metricLabel}>Популярных</span>
                <span className={s.metricValue}>
                  {stats.popular.toLocaleString('ru-RU')}
                </span>
              </div>
            </div>

            <h2 className={s.sectionTitle}>По источникам API</h2>
            <div className={s.metrics}>
              {Object.entries(stats.byApi)
                .sort((a, b) => b[1] - a[1])
                .map(([apiName, count]) => (
                  <div key={apiName} className={s.metricCard}>
                    <span className={s.metricLabel}>{apiName}</span>
                    <span className={s.metricValue}>
                      {count.toLocaleString('ru-RU')}
                    </span>
                    <span className={s.metricSub}>
                      {stats.total > 0
                        ? Math.round((count / stats.total) * 100)
                        : 0}
                      %
                    </span>
                  </div>
                ))}
            </div>

            <div className={s.reloadWrap}>
              <button className="btn grey" onClick={loadData}>
                Обновить
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PricesStat;
